export interface IUserSettingFilter {
  id?: number,
  businessId: number,
  userId: number,
  type: number,
  name: string,

  // type 1 => 999: sẽ có dạng string lưu link đã lọc
  // type 5.000 => 5.999: sẽ có dạng string[] lưu mảng các cột lọc yêu thích
  filterValues: string | string[],
  createdDateTime?: string,

  // Trường dữ liệu lấy từ cache
  key?: number, // Auto IC
  sortOrder?: number, // Lưu giá trị sắp xếp của filter
  isHide?: boolean, // Dùng để lưu cài đặt ẩn hiện bộ lọc trên danh sách tabs của trang
  tabRef?: string | number, // Lưu ref tab mặc định
}

export const UserSettingFilterConsts = {
  FILTER_PRODUCT_LIST: 1,
  FILTER_INVENTORY_LIST: 2,
  FILTER_POS_LIST: 3,
  FILTER_ORDER_LIST: 4,
  FILTER_CUSTOMER_LIST: 5,
  FILTER_WEBSITE_LIST: 6,
  FILTER_PROMOTION_LIST: 7,
  FILTER_ACCOUNTING_LIST: 8,
  FILTER_REPORT_LIST: 9,
  FILTER_WARRANTY_LIST: 10,
  FILTER_SETTING_LIST: 11,
  FILTER_PRODUCT_EXPIRE_LIST: 12,

  FILTER_PRODUCT_LOGPRICE: 12,

  //ECOMMERCE
  FILTER_ECOMERCE_LAZADA_ORDER: 13,
  FILTER_ECOMERCE_SHOPEE_ORDER: 14,
  FILTER_ECOMERCE_SENDO_ORDER: 15,
  FILTER_ECOMERCE_TIKI_ORDER: 16,
  FILTER_ECOMERCE_LAZADA_PRODUCT: 17,
  FILTER_ECOMERCE_SHOPEE_PRODUCT: 18,
  FILTER_ECOMERCE_SENDO_PRODUCT: 19,
  FILTER_ECOMERCE_TIKI_PRODUCT: 20,
  FILTER_ECOMERCE_TIKTOK_PRODUCT: 21,
  FILTER_ECOMERCE_TIKTOK_ORDER: 22,

  /**
   * -------------------------------------------------------------------------------------------------------------
   * START: Khai báo type cho phần cài đặt bộ lọc yêu thích
   * @Note:
   * - Type từ 5.000 đến 5999 sẽ dành để lưu những type cài đặt bộ lọc yêu thích.
   * - Việc đặt từ 5k trở lên để tránh trường hợp trùng type cài đặt "bộ lọc đã lưu" tiện cho việc mở rộng về sau.
   * -------------------------------------------------------------------------------------------------------------
   */
  FILTER_FAVOURITE_PRODUCT_ITEM_INDEX: 5000,
  FILTER_FAVOURITE_ORDER_MANAGE_INDEX: 5001,

  /**
   * -------------------------------------------------------------------------------------------------------------
   * END: Khai báo type cho phần cài đặt bộ lọc yêu thích
   * -------------------------------------------------------------------------------------------------------------
   */
}

export const FILTER_FAVOUR_NAME: Record<number, string> = {
  [UserSettingFilterConsts.FILTER_FAVOURITE_PRODUCT_ITEM_INDEX]: 'Danh sách sản phẩm',
  [UserSettingFilterConsts.FILTER_FAVOURITE_ORDER_MANAGE_INDEX]: 'Danh sách đơn hàng'
}
